// 年齢確認（成人向けサイトとしての設定）。AgeGate（画面）と gatsby-ssr.js（最初の描画の前の覆い）が同じ値を使う。
// ページの HTML には中身をそのまま出し、確認はブラウザだけで出す（検索エンジンや DMM の巡回を年齢確認で止めない）。

export const AGE_GATE_KEY = "doujinanalytica:age-ok" // localStorage。答えた時刻（ms）
export const AGE_GATE_DAYS = 30 // 「18歳以上です」を押してから、また確認するまでの日数
export const AGE_GATE_BOTS = "bot|crawl|spider|slurp|lighthouse|inspectiontool" // 検索エンジンなどには出さない

export const isBot = ua => new RegExp(AGE_GATE_BOTS, "i").test(ua || "")

// まだ答えていないか、答えてから AGE_GATE_DAYS 日を過ぎたか
export const needsAgeGate = () => {
  try {
    const at = Number(window.localStorage.getItem(AGE_GATE_KEY))
    return !(at && Date.now() - at < AGE_GATE_DAYS * 864e5)
  } catch {
    return true // 保存できない環境では毎回たずねる
  }
}

// head に入れる小さなスクリプト。React が動く前に <html data-age-gate="pending"> を付け、
// 下の AGE_GATE_STYLE で画面を覆う（確認の前に中身が一瞬見えないように）
export const AGE_GATE_SCRIPT = `(function(){try{if(new RegExp(${JSON.stringify(
  AGE_GATE_BOTS
)},"i").test(navigator.userAgent||""))return;var t=Number(localStorage.getItem(${JSON.stringify(
  AGE_GATE_KEY
)}));if(t&&Date.now()-t<${AGE_GATE_DAYS}*864e5)return}catch(e){}document.documentElement.setAttribute("data-age-gate","pending")})();`

export const AGE_GATE_STYLE =
  'html[data-age-gate="pending"] body{overflow:hidden}' +
  'html[data-age-gate="pending"] body::after{content:"";position:fixed;inset:0;z-index:2147483000;' +
  "background:rgba(13,17,22,.88);-webkit-backdrop-filter:blur(18px);backdrop-filter:blur(18px)}"
